requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded(['modal-opener.js'], () => {
    themeBase.onDOMContentLoadedTrigger(() => {
      if (!customElements.get('navigation-drawer')) {
        class NavigationDrawer extends ModalDialog {
          constructor() {
            super();

            this.mainDetailsToggle = this.querySelector('details');
            this.buttonBack = document.querySelector('.js-menu-drawer-back');
            this.modalOverlay = this.querySelector('.modal-overlay');
            this.menuDrawer = document.querySelector('#menu-drawer');
            this.inner = document.querySelector('.mobile-facets__inner');
            delegate(this, 'click', 'summary', this.onSummaryClick.bind(this));
            delegate(this, 'click', '.js-navigation-drawer-back', this.onCloseButtonClick.bind(this));
          }

          show() {
            super.show(...arguments);
          }

          hide(callback) {

            super.hide(callback);
          }

          onSummaryClick(event) {
            const parentDetails = event.target.closest('details');
            const summaryElement = parentDetails.classList.contains('menu-drawer-container') ? this.querySelector('summary') : parentDetails.querySelector('summary');
            const detailsElement = summaryElement.parentNode;

            const isOpen = detailsElement.hasAttribute('open');
            const reducedMotion = {
              matches: false
            };

            function addTrapFocus() {
              trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
              summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
            }

            if (detailsElement === this.mainDetailsToggle) {
              if (isOpen) event.preventDefault();
              isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
            } else {
              setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
                this.checkMenuState();
              }, 100);
            }
          }

          checkMenuState() {
            this.classList.toggle('has-opened-menu', this.querySelectorAll('.menu-opening').length > 0);
          }

          openMenuDrawer(summaryElement) {
            if (this.inner) {
              this.inner.removeEventListener('transitionend', this.onCloseTransitionend);
            }

            setTimeout(() => {
              this.mainDetailsToggle.classList.add('menu-opening');
            }, 100);
            summaryElement.setAttribute('aria-expanded', true);
            trapFocus(this.mainDetailsToggle, summaryElement);

            themeBase.freezeScroll({
              breakpoint: this.dataset.breakpoint,
              additionalClass: 'body-menu-opening'
            });
          }

          onCloseTransitionend() {
            document.body.classList.remove('body-menu-opening');
          }

          closeMenuDrawer(event, elementToFocus = false) {
            if (event !== undefined) {
              if (this.inner) {
                this.inner.removeEventListener('transitionend', this.onCloseTransitionend);
                this.inner.addEventListener('transitionend', this.onCloseTransitionend, {
                  once: true
                });
              }

              this.mainDetailsToggle.classList.remove('menu-opening');
              this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
              });
              removeTrapFocus(elementToFocus);
              this.closeAnimation(this.mainDetailsToggle);
            }
            themeBase.unfreezeScroll();
          }

          onCloseButtonClick(event) {
            const detailsElement = event.target.closest('details');
            const summaryElement = detailsElement.querySelector('summary');

            summaryElement.focus();
            this.closeSubmenu(detailsElement);
            this.checkMenuState();
          }

          closeSubmenu(detailsElement) {
            detailsElement.classList.remove('menu-opening');
            detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
            removeTrapFocus();
            this.closeAnimation(detailsElement);
          }

          closeAnimation(detailsElement) {
            let animationStart;

            const handleAnimation = (time) => {
              if (animationStart === undefined) {
                animationStart = time;
              }

              const elapsedTime = time - animationStart;

              if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
              } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                  trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
              }
            }

            window.requestAnimationFrame(handleAnimation);
          }
        }

        scriptController.onStyleReady(() => {
          window.NavigationDrawer = NavigationDrawer;
          customElements.define('navigation-drawer', NavigationDrawer);
          scriptController.scripts.push('navigation-drawer.js');
        }, ['component-navigation-drawer']);

        if (!customElements.get('facets-drawer')) {
          class FacetsDrawer extends NavigationDrawer {
            constructor() {
              super();
            }
          }

          scriptController.onStyleReady(() => {
            customElements.define('facets-drawer', FacetsDrawer);
          }, ['component-facets']);
        }
      }
    });
  });
});